import { Component, Inject, ViewEncapsulation, ViewChild, ElementRef, OnChanges, SimpleChanges, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18N } from 'ess-plugin-base';
import { StoredFile } from '../../model/file';

export interface FolderSelectData {
    title: string,
    resource: string;
    disabled_id: number;
}

@Component({
    selector: 'folder-dialog',
    templateUrl: './folder.dialog.html',
    styleUrls: ['./folder.dialog.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FolderDialog implements OnChanges, OnInit {

    selected: StoredFile;

    // @ViewChild('input', {static: true})
    // input: ElementRef;

    defaultTitle: string = 'Select Folder';
    
    @Input('resource')
    resource: string;

    // canRename: boolean;
    // canDelete: boolean;

    // newFolder: string = '';

    constructor(public dialogRef: MatDialogRef<FolderDialog>, public i18n: I18N, 
        @Inject(MAT_DIALOG_DATA) public data: FolderSelectData) {

            if (data) this.resource = data.resource;
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    ngOnInit() {
        this.switchTitle();
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.switchTitle();
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    switchTitle() {
        // this.canDelete = this.data.action == FileAction.DELETE_FILE || this.data.action == FileAction.DELETE_FOLDER;

        // this.canRename = this.data.action != FileAction.DELETE_FILE && this.data.action != FileAction.DELETE_FOLDER;

        // if (this.data && this.data.action) {
        //     switch(this.data.action) {
        //         case FileAction.NEW_FOLDER: this.defaultTitle = this.i18n.get('file.new_folder', 'New Folder');
        //         break;
        //         case FileAction.RENAME_FILE: this.defaultTitle = this.i18n.get('file.rename_file', 'Rename File');
        //         break;
        //         case FileAction.RENAME_FOLDER: this.defaultTitle = this.i18n.get('file.rename_folder', 'Rename Folder');
        //         break;
        //         case FileAction.DELETE_FOLDER: this.defaultTitle = this.i18n.get('file.delete_file', 'Delete File');
        //         break;
        //         case FileAction.DELETE_FOLDER: this.defaultTitle = this.i18n.get('file.delete_folder', 'Delete Folder');
        //         break;
        //     }
        // }
    }

    folderSelected(event: StoredFile) {
        // if (!event) return;
        // let p = event.path || '';
        // if (p.length) {
        //     if (p.startsWith('/')) p = p.substring(1);
        //     if (p.length) p += '/';
        // }
        // p += event.filename;
        if (event) {
            this.selected = event
        } else {
            this.selected = new StoredFile();
            this.selected.id = -1;
        }

        // this.path = p;
        // this.selected_folder_id = event.id;
    }
        
    close() {
        this.dialogRef.close();
    }

    // delete() {
    //     this.dialogRef.close('__DELETE__');
    // }

    save() {
        // this.dialogRef.close(this.data.path + '/' + this.input.nativeElement.value);
        // this.dialogRef.close(this.input.nativeElement.value);
        this.dialogRef.close(this.selected);
    }

}